import { Schema as S } from "effect";
const PercentageZeroToOne = S.Number.pipe(S.greaterThanOrEqualTo(0), S.lessThanOrEqualTo(1), S.annotations({
    title: "Percentage",
    description: "A percentage between 0 and 1",
    examples: [
        0,
        0.1,
        0.25,
        0.5,
        0.75,
        1
    ]
}), S.brand("@open-revenue/schema/Percentage/ZeroToOne"));
export const Percentage = {
    ZeroToOne: {
        Schema: PercentageZeroToOne,
        Type: PercentageZeroToOne.Type
    }
};
